import React, { memo } from "react";
import { useTranslation } from "react-i18next";
import GuidanceLink from "../components/guidance/GuidanceLink";
import { RECORDING_MODES } from "../utils/recordingModes";

function GuidancePage({ isPermitted }) {
  const { t } = useTranslation();
  const canSeeMode = (mode) =>
    typeof isPermitted === "function" ? isPermitted(mode) : true;

  const showSpirometryTips = canSeeMode(RECORDING_MODES.SPIROMETRY);
  const showCardiopulmonaryTips = canSeeMode(RECORDING_MODES.TIDAL);

  return (
    <div className="w-full max-w-lg h-full min-h-0 overflow-y-auto p-4">
      <section className="min-h-full flex flex-col gap-2">
        <header className="flex flex-col items-start text-start gap-1">
          <h1 className="subtitle-text">
            {t("guidance.index.title", "Guidance")}
          </h1>
          <p className="">
            {t(
              "guidance.index.intro",
              "Find tips to help improve your next recording.",
            )}
          </p>
        </header>

        <div className="flex flex-col w-full">
          <GuidanceLink
            to="/guidance/general"
            // icon="info"
            title={t("guidance.index.generalTitle", "General tips")}
            body={t(
              "guidance.index.generalBody",
              "Camera setup, lighting, positioning, and staying still.",
            )}
          />

          {showSpirometryTips ? (
            <GuidanceLink
              to="/guidance/spirometry"
              // icon="air"
              title={t("guidance.index.spirometryTitle", "Spirometry tips")}
              body={t(
                "guidance.index.spirometryBody",
                "Tips for signal quality and the forced breathing manoeuvre.",
              )}
            />
          ) : null}

          {showCardiopulmonaryTips ? (
            <GuidanceLink
              to="/guidance/cardiopulmonary"
              title={t(
                "guidance.index.cardiopulmonaryTitle",
                "Cardiopulmonary tips",
              )}
              body={t(
                "guidance.index.cardiopulmonaryBody",
                "Tips for cardiac and respiratory signal quality.",
              )}
            />
          ) : null}
        </div>
      </section>
    </div>
  );
}

export default memo(GuidancePage);
